import { Box } from '@mui/system';
import { useCallback, useState } from 'react';
import { PageFilterSection } from 'src/shared/components/organisms/pageFilterSection';
import SearchField from 'src/shared/components/form/searchField';
import { SelectionDataGrid } from '../components/selectionDataGrid';
import { SelectionDetails } from '../components/selectionDetails';

type SelectionDetailModalState = {
  open: boolean;
  selectionId: number | undefined;
};

export const MemberSelectionPage = () => {
  const [refetchSelectionsDataGrid, setRefetchSelectionsDataGrid] = useState<boolean>(false);
  const [searchString, setSearchString] = useState<string | undefined>(undefined);
  const [, setLoading] = useState<boolean>(true);
  const [selectionDetailModal, setSelectionDetailModal] = useState<SelectionDetailModalState>({
    open: false,
    selectionId: undefined,
  });

  const loadingCallback = useCallback((isLoading: boolean) => {
    setLoading(isLoading);
  }, []);

  return (
    <>
      <PageFilterSection
        leftContent={
          <SearchField
            initialValue={searchString}
            onSearch={(newSearchString) => {
              setSearchString(newSearchString);
            }}
          />
        }
      />
      <Box className='section-inset'>
        <SelectionDataGrid
          loadingCallback={loadingCallback}
          setSelectionDetailModal={setSelectionDetailModal}
          refetchSelectionsDataGrid={refetchSelectionsDataGrid}
          setRefetchSelectionsDataGrid={setRefetchSelectionsDataGrid}
          searchString={searchString || ''}
        />
      </Box>
      {selectionDetailModal.open && selectionDetailModal.selectionId && (
        <SelectionDetails
          key={selectionDetailModal.selectionId}
          selectionId={selectionDetailModal.selectionId}
          setSelectionDetailModal={setSelectionDetailModal}
          setRefetchSelectionsDataGrid={setRefetchSelectionsDataGrid}
        />
      )}
    </>
  );
};
